import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const ADMIN_COLS = [
  { label: 'Label',      flex: 1.2 },
  { label: 'Member',     flex: 1.2 },
  { label: 'Flat / Bldg', flex: 1.2 },
  { label: 'Address',    flex: 2.2 },
  { label: 'City',       flex: 0.9 },
  { label: 'State',      flex: 0.9 },
  { label: 'Pincode',    flex: 0.7 },
];

const MEMBER_COLS = [
  { label: 'Label',      flex: 1.4 },
  { label: 'Flat / Bldg', flex: 1.4 },
  { label: 'Address',    flex: 2.6 },
  { label: 'City',       flex: 1.0 },
  { label: 'State',      flex: 1.0 },
  { label: 'Pincode',    flex: 0.8 },
];

const joinAddr = (r) => [r.addressLine1, r.addressLine2].filter(Boolean).join(', ') || '-';
const joinFlat = (r) => [r.flatNo, r.buildingName].filter(Boolean).join(', ') || '-';

export default function AddressBookDocument({ data, theme: themeKey, orientation, sections }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const rows = Array.isArray(data.rows) ? data.rows : [];
  const isAdmin = !!data.isAdmin;
  const cols = isAdmin ? ADMIN_COLS : MEMBER_COLS;

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Address Book" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && data.filters && <PdfFilterLine filters={data.filters} theme={t} />}
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Addresses', value: String(rows.length), color: t.primary },
            ]} />
          )}
          <PdfTableHead cols={cols} theme={t} />
          {rows.map((row, i) => (
            <PdfTableRow key={i} cols={cols} index={i} theme={t}
              values={isAdmin
                ? [
                    row.label        || '-',
                    row.memberName   || '-',
                    joinFlat(row),
                    joinAddr(row),
                    row.city         || '-',
                    row.state        || '-',
                    row.pincode      || '-',
                  ]
                : [
                    row.label        || '-',
                    joinFlat(row),
                    joinAddr(row),
                    row.city         || '-',
                    row.state        || '-',
                    row.pincode      || '-',
                  ]
              }
            />
          ))}
          <PdfTableFoot cols={cols}
            values={[`Total: ${rows.length} address${rows.length !== 1 ? 'es' : ''}`, ...Array(cols.length - 1).fill('')]}
            theme={t}
          />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}
